import React from "react";
import { useSelector } from "react-redux";

function ReviewProfileDetails() {
  const fields = useSelector((state) => state.deviceProfile.ui.form.fields.step1);

  return (
    <>
      <div
        className="font-face-vzw py-1"
        style={{
          fontWeight: 700,
          fontSize: "20px",
          color: "#6F7171",
        }}
      >
        Profile details
      </div>
      <div className="py-2 w-100 d-flex flex-row justify-content-start align-items-center">
        <div className="w-50 d-flex flex-column justify-content-center align-items-start">
          <span className="d-flex flex-row justify-content-start align-items-center font-face-vzw shipment-clone-font-size">
            Profile Name
          </span>
          <div className="txt-label" style={{
           whiteSpace: "normal",
           wordBreak: "break-word",
           overflowWrap: "break-word",
          }}>{fields?.profileName?.value}</div>
        </div>
        <div className="w-50 d-flex flex-column justify-content-center align-items-start">
          <span className="d-flex flex-row justify-content-start align-items-center font-face-vzw shipment-clone-font-size">
             Profile type
          </span>
          <div className="txt-label">{fields?.profileType?.value==="nonshipment"?"Non-shipment":"Shipment"}</div>
        </div>
      </div>
       <div className="py-2 w-100 d-flex flex-row justify-content-start align-items-center">
        <div className="w-50 d-flex flex-column justify-content-center align-items-start">
          <span className="d-flex flex-row justify-content-start align-items-center font-face-vzw shipment-clone-font-size">
            Device model
          </span>
          <div className="txt-label" style={{
           whiteSpace: "normal",
           wordBreak: "break-word",
           overflowWrap: "break-word",
          }}>{fields?.deviceType?.value}</div>
        </div>
        <div className="w-50 d-flex flex-column justify-content-center align-items-start">
          <span className="d-flex flex-row justify-content-start align-items-center font-face-vzw shipment-clone-font-size">
            Description
          </span>
          <div className="txt-label">{fields?.description?.value}</div>
        </div>
      </div>
    </>
  );
}

export default ReviewProfileDetails;
